import { useTranslations } from '@vocab/react';
import { Alert, Stack, Strong, Text, TextLink } from 'braid-design-system';
import React from 'react';

import { useLocalisedRoutes } from 'src/app/views/hooks/useLocalisedRoutes';

import translations from './.vocab';

export default () => {
  const { t } = useTranslations(translations);
  const { createContactUsUrl } = useLocalisedRoutes();

  return (
    <Alert tone="info">
      <Stack space="medium">
        <Text>
          <Strong>{t('role-requirements-error-heading')}</Strong>
        </Text>
        <Stack space="small">
          <Text>{t('role-requirements-error-subheading')}</Text>
          <Text>
            {t('role-requirements-error-text', {
              Link: (children) => (
                <TextLink href={createContactUsUrl()}>{children}</TextLink>
              ),
            })}
          </Text>
        </Stack>
      </Stack>
    </Alert>
  );
};
